<template>
  <div>
    <div v-if="bind_success">
      <div
        v-if="conference && (content_id === conference.live_content_id || content_id === conference.live_warmup_content_id || content_id === conference.live_reminder_content_id || content_id === conference.live_highlight_content_id)"
        class="bind-success"
      >
        <div v-if="htmlContent" :class="{'html-content': true, 'space-for-live-buttons': showStatusBar}" v-html="htmlContent"></div>
        <!-- <div style="height: 110px;"></div> -->
        <div v-if="showStatusBar" class="live-buttons">
          <div v-if="!isStarted" class="button-group">
            <button
              v-if="!is_reserved"
              class="button"
              @click="showPopupLive = true"
            >
              预约直播
            </button>
            <div v-else class="reserve_status">
              您已预约，请到时打开<span @click="handleEnterLive">此</span>链接观看
            </div>
            <button
              class="button button-outline"
              @click="showPopupQuestion = true"
            >
              我要提问
            </button>
          </div>
          <button
            v-if="isStarted"
            class="button"
            style="margin-top: 10px"
            @click="handleEnterLive"
          >
            进入直播
          </button>
          <div v-if="countdown > 0" class="countdown">
            <div style="font-size: 16px">离直播还有：</div>
            <van-count-down
              style="color: #fff; line-height: none"
              :time="countdown"
              format="DD 天 HH 时 mm 分 ss 秒"
            >
              <template #default="timeData">
                <span class="block">{{ timeData.days }}</span>
                <span class="colon">天</span>
                <span class="block">{{ timeData.hours }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.minutes }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
          </div>
        </div>
        <div
          v-if="conference && content_id === conference.onsite_content_id"
          class="bind-success"
        >
          <img src="/resource/live/live-invitation-onsite.jpg" class="poster" />
          <button
            v-if="!is_accepted"
            class="button"
            @click="showPopupOnsite = true"
          >
            确认参会
          </button>
          <div v-else class="reserve_status">您已确认参会，谢谢您的支持。</div>
          <div style="height: 80px"></div>
          <img
            src="/resource/live/live-invitation-bottom.jpg"
            class="poster bottom"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <img class="spinner" src="/image/spinner.gif" />
    </div>

    <van-popup v-model="showPopupLive" position="bottom">
      <div class="popup-content phone">
        <van-field
          v-model="phone"
          :border="false"
          type="tel"
          label="手机"
          name="phoneRule"
          placeholder="手机号码"
          :rules="[{validator: phoneRule, message: '请输入正确的手机号码'}]"
        />
        <button class="button" @click="handleReserve">提交预约</button>
      </div>
    </van-popup>

    <van-popup v-model="showPopupOnsite" position="bottom">
      <div class="popup-content">
        <div style="font-size: 14px; color: #999">请确认您要参加的会场</div>
        <van-field
          v-model="selectedCity"
          placeholder="请选择会场"
          readonly
        />
        <van-popup v-model="showCityPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="cities"
            @confirm="onCityConfirm"
            @cancel="onCityCancel"
          />
        </van-popup>
        <button class="button" style="width: 80%; border-radius: 30px" @click="handleAccept">确认参会</button>
      </div>
    </van-popup>

    <van-popup v-model="showPopupQuestion" position="bottom" closeable class="question-popup">
      <div class="popup-content question">
        <div class="question-header">我要提问</div>
        <div class="question-body">
          <div class="label" style="color: #333; font-weight: bold; margin-bottom: 8px;">直播会议名称</div>
          <div class="value" style="color: #666; margin-bottom: 20px;">{{ conference ? conference.conference_name : '' }}</div>

          <div class="label" style="color: #333; font-weight: bold; margin-bottom: 8px;"><span class="required" style="color: #aa341b;">*</span> 反馈内容</div>
          <van-field
            v-model="askForm.content"
            type="textarea"
            maxlength="1000"
            placeholder="请详细描述您的问题..."
            show-word-limit
            class="custom-textarea"
          />

          <div class="label" style="color: #333; font-weight: bold; margin-top: 20px; margin-bottom: 8px;"><span class="required" style="color: #aa341b;">*</span> 联系邮箱</div>
          <van-field
            v-model="askForm.email"
            placeholder="请留下您的邮箱，方便我们回复"
            class="custom-input"
          />

          <button class="button submit-btn" style="width: 100%; border-radius: 5px; margin-top: 20px;" @click="submitQuestion">发送</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {getLocalStorage, setLocalStorage} from '@/utils/index';
import {getWeChatInfoByCode, getWeChatConfig} from '@/api/wechat';
import {
  getPhysicianWechatDetailByOpenId,
  logContentOpen,
  logContentOpenDuration,

} from '@/api/content';
import {
  getConference,
  GetRegister,
  ConferenceReserve,
  ConferenceAccept,
  GetConferenceReservation,
  GetConferenceInvitation,
  GetConferenceUrl,
  SubmitFeedback,
} from '@/api/live';
import CryptoJS from 'crypto-js';
import {weixinOASDK} from '@/utils/weixinOA';
import {Popup, Field, Toast, Picker, CountDown} from 'vant';
import * as moment from 'moment';

export default {
  name: 'BindSuccess',
  components: {
    'van-field': Field,
    'van-popup': Popup,
    'van-picker': Picker,
    'van-count-down': CountDown,
  },
  data() {
    return {
      bind_success: false,
      open_id: '',
      code: '',
      conference_id: '',
      content_id: '',
      send_id: '',
      ref_id: '',
      physician_id: null,
      ext_physician_id: null,
      physician_name: '',
      city: '',
      province: '',
      conference: null,
      participation_type: '',
      phone: '',
      showPopupLive: false,
      showPopupOnsite: false,
      showPopupQuestion: false,
      askForm: {
        content: '',
        email: ''
      },
      is_accepted: false,
      is_reserved: false,
      cities: [
        '上海',
        '北京',
        '天津',
        '杭州',
        '广州',
        '成都',
        '武汉',
        '沈阳',
        '济南',
        '石家庄',
        '长沙',
        '重庆',
      ],
      selectedCity: '',
      showCityPicker: false,
      countdown: '',
      isStarted: false,
      htmlContent: null,
      logOpenId: '',
      ticks: 0,
      intervalId: null,
      showStatusBar: false,
    };
  },
  async created() {
    this.open_id = getLocalStorage('open_id');

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    this.content_id = urlParams.get('cid');
    this.send_id = urlParams.get('send_id');
    this.ref_id = urlParams.get('ref_id');

    if (code) {
      let res = await getWeChatInfoByCode(code);
      console.log(res);
      // Fake open_id
      if (code === 'test0123') {
        res = {
          data: {
            openid: 'fake_openid_0001',
          },
          isSuccess: true,
          message: '',
        };
      }
      if (res.data && res.data.token) {
        setLocalStorage('token', res.data.token);
        setLocalStorage('seed', res.data.seed);
      }
      if (res.data && res.data.user && res.data.user.openid) {
        this.open_id = res.data.user.openid;
        setLocalStorage('open_id', this.open_id);
      } else {
        // Error
        return;
      }
    }

    if (this.open_id) {
      try {
        const physicianWechatRes = await getPhysicianWechatDetailByOpenId(this.open_id);
        if (
          physicianWechatRes &&
          physicianWechatRes.data &&
          physicianWechatRes.data.physician_id
        ) {
          // 存在医生
          this.physician_id = physicianWechatRes.data.physician_id;
          this.physician_name = physicianWechatRes.data.physician_name;
          this.phone = physicianWechatRes.data.mobile_phone || '';
          this.city = physicianWechatRes.data.city;
          this.province = physicianWechatRes.data.province;
        } else {
          // 获取外部医生
          const extPhysicianRes = await GetRegister(this.open_id);
          if (extPhysicianRes && extPhysicianRes.data) {
            this.ext_physician_id = extPhysicianRes.data.ext_physician_id;
            this.physician_name = extPhysicianRes.data.physician_name;
            this.phone = extPhysicianRes.data.mobile_phone || '';
            this.city = extPhysicianRes.data.city;
            this.province = extPhysicianRes.data.province;
          } else {
            // 医生注册
            window.location.href = `/public/register?cid=${this.content_id}`;
          }
        }
      } catch (e) {
        // 捕获401错误并调用authorize
        if (e && e.response && e.response.status === 401) {
          this.authorize();
        } else {
          // 其他错误处理
          console.error(e);
        }
        return;
      }

      await this.loadConference();

      this.bind_success = true;

      // 检查时间，直播开始前30分钟内，直接跳转到直播间
      console.log(this.conference?.status);
      if (this.conference?.status === 'upcoming' ||
        this.conference?.status === 'warmup' ||
        this.conference?.status === 'reminder') {
        this.showStatusBar = true;

        const startTime = moment(this.conference.start_time);
        const now = moment();
        const diffMinutes = startTime.diff(now, 'minutes');
        console.log('diffMinutes', diffMinutes);
        if (diffMinutes <= 30) {
          this.isStarted = true;
          console.log('进入直播间');
          this.handleEnterLive();
          return;
        }
      }

      if (this.conference?.live_playback_content_id &&
        this.conference?.live_playback_content_id === this.content_id) {
        this.isStarted = true;
        console.log('进入直播间');
        this.handleEnterLive();
        return;
      }
    } else {
      this.authorize();
    }
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  unmounted() {
    // Vue 3 中使用 unmounted
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async loadConference() {
      // 记录打开日志
      let logOpenParams = {
        log_content_send_id: this.send_id,
        content_id: this.content_id,
        reader_physician_id: this.physician_id,
        reader_ext_physician_id: this.ext_physician_id,
        reader_openid: this.open_id,
      };
      logContentOpen(logOpenParams).then((res) => {
        if (res && res.data) {
          this.logOpenId = res.data;
        }
      });

      const conference = await getConference(this.content_id);
      if (conference.data) {
        this.conference = conference.data;
        this.conference_id = this.conference.conference_id;
        // 获取倒计时
        this.countdown = moment(this.conference.start_time).diff(moment());
        if (this.content_id === this.conference.live_content_id) {
          this.participation_type = 'live';
          const reservationRes = await GetConferenceReservation(
            this.conference_id,
            this.participation_type,
            // this.content_id,
            this.open_id,
          );
          if (reservationRes && reservationRes.data) {
            this.is_reserved = reservationRes.data.is_reserved;
          }

          if (this.conference.live_content.content_body) {
            this.htmlContent = this.conference.live_content.content_body;
          }
        } else if (this.content_id === this.conference.live_warmup_content_id) {
          this.participation_type = 'live';
          const reservationRes = await GetConferenceReservation(
            this.conference_id,
            this.participation_type,
            this.open_id,
          );
          if (reservationRes && reservationRes.data) {
            this.is_reserved = reservationRes.data.is_reserved;
          }

          if (this.conference.live_warmup_content.content_body) {
            this.htmlContent = this.conference.live_warmup_content.content_body;
          }
        } else if (this.content_id === this.conference.live_reminder_content_id) {
          this.participation_type = 'live';
          const reservationRes = await GetConferenceReservation(
            this.conference_id,
            this.participation_type,
            this.open_id,
          );
          if (reservationRes && reservationRes.data) {
            this.is_reserved = reservationRes.data.is_reserved;
          }

          if (this.conference.live_reminder_content.content_body) {
            this.htmlContent = this.conference.live_reminder_content.content_body;
          }
        } else if (this.content_id === this.conference.live_highlight_content_id) {
          this.participation_type = 'live';
          const reservationRes = await GetConferenceReservation(
            this.conference_id,
            this.participation_type,
            this.open_id,
          );
          if (reservationRes && reservationRes.data) {
            this.is_reserved = reservationRes.data.is_reserved;
          }

          if (this.conference.live_highlight_content.content_body) {
            this.htmlContent = this.conference.live_highlight_content.content_body;
          }
        } else {
          this.participation_type = 'onsite';
          const invitationRes = await GetConferenceInvitation(
            this.conference_id,
            this.content_id,
            this.open_id,
          );
          if (invitationRes && invitationRes.data) {
            this.is_accepted = invitationRes.data.invitation_status === 1;
          }

          // if (this.conference.onsite_content.content_body) {
          //   this.htmlContent = this.conference.onsite_content.content_body;
          // }
        }
        if (this.city && this.cities.includes(this.city.replace('市', ''))) {
          this.selectedCity = this.city;
        } else {
          this.selectedCity = this.cities[0];
        }
        document.title = this.conference.conference_name;

        const forwardUrl = window.location.origin +
            '/public/live' +
            (this.content_id ? '?cid=' + this.content_id : '') +
            (this.send_id ? '&ref_id=' + this.send_id : '');

        console.log('Forward URL: ', forwardUrl);
        weixinOASDK.register({
          title: this.conference.conference_name,
          url: forwardUrl,
          description: '灵北会议邀请',
          wx_logo: this.conference.live_content.wx_logo,
        });

        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        this.intervalId = setInterval(() => {
          this.ticks++;
          if (this.ticks > (10 * 60) / 5) { // 10分钟后，每1分钟记录一次
            if (this.ticks % 12 !== 0) {
              return;
            }
          }
          if (this.logOpenId) {
            logContentOpenDuration({log_content_open_id: this.logOpenId}).then();
          }
        }, 5000);
      }
    },
    authorize() {
      getWeChatConfig().then((res) => {
        let appid = res?.data?.appid;
        let redirect_uri = encodeURIComponent(
          window.location.origin +
            '/public/live' +
            (this.content_id ? '?cid=' + this.content_id : '') +
            (this.ref_id ? '&ref_id=' + this.ref_id : ''),
        );
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=#wechat_redirect`;
      });
    },
    handleEnterLive() {
      if (this.conference.vendor_platform === 'medline' || this.conference.vendor_platform === 'medlive') {
        const user_id = this.physician_id ?? this.ext_physician_id;
        const class_id = this.conference.vender_live_id;
        const user_name = this.physician_name;
        const source = 'lingbei';
        const key = 'XQwP6OJoNNSYhyHp'; // 'cgQFPSbSKpWmWpYV';
        const timestamp = Math.floor(new Date().getTime() / 1000).toString();
        const sign = CryptoJS.MD5(user_id + source + key + timestamp).toString();
        const name = encodeURIComponent(this.encodeBase64Unicode(user_name));
        const liveUrl = `https://class.medlive.cn/class/live/show/${class_id}?tp_user=${user_id}&tp_name=${name}&tp_source=${source}&tp_sign=${sign}&tp_timestamp=${timestamp}`;
        window.location.href = liveUrl;
      } else {
        GetConferenceUrl(this.conference.conference_id, this.open_id).then(
          (res) => {
            if (res && res.isSuccess && res.data) {
              window.location.href = res.data;
            } else {
              Toast.fail('获取直播链接失败，请稍后再试');
            }
          },
        );
      }
    },
    async handleReserve() {
      if (!this.phoneRule(this.phone)) {
        Toast.fail('请输入正确的手机号码');
        return;
      }

      try {
        const response = await ConferenceReserve({
          conference_id: this.conference.conference_id,
          participation_type: this.participation_type,
          content_id: this.content_id,
          open_id: this.open_id,
          physician_id: this.physician_id,
          ext_physician_id: this.ext_physician_id,
          mobile_phone: this.phone,
        });
        if (response && response.isSuccess) {
          this.showPopupLive = false;
          Toast.success('预约成功');

          await this.loadConference();
        } else {
          Toast.fail('预约失败，请稍后再试' + response?.message ? '\n' + response?.message : '');
        }
      } catch (error) {
        console.error(error);
        Toast.fail('预约失败，请稍后再试');
      }
    },
    async handleAccept() {
      try {
        const response = await ConferenceAccept({
          conference_id: this.conference.conference_id,
          participation_type: this.participation_type,
          content_id: this.content_id,
          open_id: this.open_id,
          physician_id: this.physician_id,
          ext_physician_id: this.ext_physician_id,
          city: this.selectedCity,
        });
        if (response && response.isSuccess) {
          this.showPopupOnsite = false;
          Toast.success('确认成功');

          await this.loadConference();
        } else {
          Toast.fail('确认失败，请稍后再试' + response?.message ? '\n' + response?.message : '');
        }
      } catch (error) {
        console.error(error);
        Toast.fail('确认失败，请稍后再试');
      }
    },
    encodeBase64Unicode(str) {
      return btoa(
        encodeURIComponent(str).replace(
          /%([0-9A-F]{2})/g,
          function (match, p1) {
            return String.fromCharCode('0x' + p1);
          },
        ),
      );
    },
    phoneRule(val) {
      return /^1[3-9]\d{9}$/.test(val);
    },
    onCityConfirm(value) {
      this.selectedCity = value;
      this.showCityPicker = false;
    },
    onCityCancel() {
      this.showCityPicker = false;
    },
    async submitQuestion() {
      if (!this.askForm.content) {
        Toast.fail('请填写反馈内容');
        return;
      }
      if (!this.askForm.email) {
        Toast.fail('请填写联系邮箱');
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.askForm.email)) {
        Toast.fail('请填写正确的联系邮箱');
        return;
      }

      const feedbackData = {
        account_id: getLocalStorage('user_id') || "",
        feedback_category: "直播会议提问",
        feedback_content: this.askForm.content,
        contact_email: this.askForm.email,
        weixin_openid: this.open_id || "",
        weixin_unionid: getLocalStorage('union_id') || "",
        physician_id: this.physician_id || "",
        ext_physician_id: this.ext_physician_id || null,
        reference: this.conference?.conference_id || "",
      };

      try {
        const res = await SubmitFeedback(feedbackData);
        if (res?.isSuccess || res?.code === 200 || !res?.isSuccess) {
          Toast.success("发送成功");
          this.askForm.content = "";
          this.askForm.email = "";
          this.showPopupQuestion = false;
        }
      } catch (e) {
        Toast.fail("发送失败，请稍后重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.spinner {
  display: block;
  width: 24px;
  height: 24px;
  margin: 60px auto 120px auto;
}
.bind-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  min-height: 100vh;
  background-color: #fff;
  .banner {
    background-color: #b92505;
    width: 100%;
    height: 300px;
    text-align: center;
  }
  .poster {
    width: 100%;
  }
  .countdown {
    // background: url('/resource/live/live-invitation-bottom.jpg');
    height: 28px;
    width: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2c3e50;
    .colon {
      display: inline-block;
      margin: 0 4px;
      color: #2c3e50;
    }
    .block {
      display: inline-block;
      width: 22px;
      color: #aa341b;
      font-size: 15px;
      text-align: center;
      background-color: #edece5;
      border-radius: 5px;
    }
  }
  // .bottom {
  //   position: absolute;
  //   bottom: 0;
  // }
  .success-title {
    font-size: 18px;
    color: #fff;
    margin-bottom: 40px;
  }

  .logo {
    width: 100px;
    height: 45px;
    margin: 40px 0;
  }

  .success-text {
    font-size: 16px;
    color: #333;
    line-height: 1.6;
    margin: 30px 0;
  }
}

.popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  input[type='tel'] {
    width: 80%;
    padding: 10px;
    margin: 20px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    text-align: left;
  }
}

.button {
  width: 60%;
  height: 30px;
  background: #aa341b;
  color: #fff;
  border: none;
  border-radius: 30px;
  font-size: 15px;
  margin-top: 10px;
  margin-bottom: 10px;

  &:active {
    opacity: 0.9;
  }
}

.button-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  width: 100%;
  padding: 0 10%;
  box-sizing: border-box;
  .reserve_status {
    width: 48%;
    font-size: 13px;
    margin: 0;
  }
  .button {
    width: 48%;
    height: 36px;
    border-radius: 5px;
    margin: 0;
  }
}

.button-outline {
  background: #fff;
  color: #aa341b;
  border: 1px solid #aa341b;
}

.reserve_status {
  font-size: 15px;
  margin-top: 10px;
  margin-bottom: 5px;
}
::v-deep .van-field__control {
  text-align: center;
  font-size: 16px;
}
.phone ::v-deep .van-field__control {
  text-align: left;
  font-size: 16px;
}
.live-buttons {
  width: 100%;
  position: fixed;
  bottom: 0;
  padding: 10px;
  height: auto;
  min-height: 80px;
  background: #f7f7f7; // #dbd7bc; //rgb(237, 236, 229);
}
.html-content {
  padding: 0;
  max-width: 100%;
  // height: calc(100vh - 80px);
  overflow: auto;
  ::v-deep img {
    width: 100%;
    height: auto;
    display: block;
  }

  &.space-for-live-buttons {
    padding-bottom: 100px;
  }
}

.question-popup {
  border-radius: 16px 16px 0 0;

  .question {
    padding: 20px;
    align-items: stretch;
    text-align: left;

    .question-header {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }

    .question-body {
      .label {
        font-size: 15px;
      }

      .value {
        font-size: 14px;
      }

      .custom-textarea {
        background-color: #f7f8fa;
        border-radius: 8px;
        padding: 10px;
        margin-bottom: 5px;

        ::v-deep .van-field__control {
          text-align: left;
        }
      }

      .custom-input {
        background-color: #f7f8fa;
        border-radius: 8px;
        padding: 10px;

        ::v-deep .van-field__control {
          text-align: left;
        }
      }
    }
  }
}
</style>
